var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"datepicker-trigger"},[_c('input',{attrs:{"id":"datepicker-trigger","type":"text","placeholder":"Select dates"}}),_c('AirbnbStyleDatepicker',{attrs:{"trigger-element-id":'datepicker-trigger',"mode":'range',"fullscreen-mobile":true,"date-one":_vm.dateOne,"date-two":_vm.dateTwo,"start-open":true,"months-to-show":1,"inline":true,"show-shortcuts-menu-trigger":false},on:{"date-one-selected":function (val) {
          _vm.dateOne = val;
        },"date-two-selected":function (val) {
          _vm.dateTwo = val;
        }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }